import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  CurrentUser: {},
  AllLanguages: [],
  AllLocations: [],
  AllCanteenUsers: [],
  AllCateringOrderStatus: [],
  AllDepartment: [],
};

export const APIResponseSlice = createSlice({
  name: "API",
  initialState,
  reducers: {
    changeCurrentUserValue: (state, action) => {
      state.CurrentUser = action.payload
    },
    changeAllLanguagesValue: (state, action) => {
     state.AllLanguages = action.payload
    },
    changeAllLocationValue: (state, action) => {
      state.AllLocations = action.payload;
    },
    changeAllCanteenUsersValue: (state, action) => {
      state.AllCanteenUsers = action.payload;
    },
    changeAllCateringOrderStatusValue: (state, action) => {
      state.AllCateringOrderStatus = action.payload;
    },
    changeAllDepartmentValue: (state, action) => {
      state.AllDepartment = action.payload;
    }
  },
});

// Action creators are generated for each case reducer function
export const {
  changeCurrentUserValue,
  changeAllLanguagesValue,
  changeAllLocationValue,
  changeAllCanteenUsersValue,
  changeAllCateringOrderStatusValue,
  changeAllDepartmentValue
} = APIResponseSlice.actions;

export default APIResponseSlice.reducer;
